const LoginLinksData = [
    {
      title: 'HQs',
      links: [
        { to: 'https://jlr.tenant.focalx.ai/', label: 'HQ JLR' },
        { to: 'https://jlruk.tenant.focalx.ai', label: 'HQ JLR UK' },
        { to: 'https://jlrbelgium.tenant.focalx.ai', label: 'HQ JLR Belgium' },
        { to: 'https://jlrnetherlands.tenant.focalx.ai', label: 'HQ JLR Netherlands' },
        { to: 'https://jlrspain.tenant.focalx.ai', label: 'HQ JLR Spain' },
        { to: 'https://jlrfrance.tenant.focalx.ai', label: 'HQ JLR France' }

      ]
    },
    {
      title: 'UK',
      links: [
        { to: 'https://jlrnorthampton.tenant.focalx.ai', label: 'JLR Northampton' },
        { to: 'https://jlrmiltonkeynes.tenant.focalx.ai', label: 'JLR Miltonkeynes' }
      ]
    },
    {
      title: 'Belgium',
      links: [
        { to: 'https://jlrkortrijk.tenant.focalx.ai', label: 'JLR Kortrijk' },
        { to: 'https://jlrschoten.tenant.focalx.ai', label: 'JLR Schoten' }
      ]
      
    },
    {
      title: 'Netherland',
      links: [
        { to: 'https://jlrutrecht.tenant.focalx.ai', label: 'JLR Utrecht' }
      ]
    },
    {
      title: 'Spain',
      links: [
        { to: 'https://jlrsevilla.tenant.focalx.ai', label: 'JLR Sevilla' },
        { to: 'https://jlrjerez.tenant.focalx.ai', label: 'JLR Jerez' }

      ]
    },
    {
      title: 'France',
      links: [
        { to: 'https://jlrmontpellier.tenant.focalx.ai', label: 'JLR Montpellier' },
        { to: 'https://jlrnimes.tenant.focalx.ai', label: 'JLR Nimes' }
      ]
    }
  ];
  
  export default LoginLinksData;
  